import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => setShowModal(false);

  return (
    <ModalContext.Provider value={{ showModal, setShowModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
